// ============================================================================
// AMAYA ENERGY — CENTRAL CONTENT CONFIG
// All site copy, brands, capabilities and markets live here. The entire site
// is data-driven from this file — adding a brand = adding one object below.
// No invented statistics, clients, locations or partnerships are used.
// ============================================================================

export const NAV_LINKS = [
  { label: 'Ecosystem', target: 'ecosystem' },
  { label: 'Brands', target: 'brands' },
  { label: 'Capabilities', target: 'capabilities' },
  { label: 'Markets', target: 'markets' },
  { label: 'Contact', target: 'contact' },
];

export const HERO = {
  lines: ['Energy', 'in', 'Motion.'],
  sub: 'Amaya Energy builds and connects the brands, technology and infrastructure of the next energy era.',
  cta: 'Explore the ecosystem',
  meta: 'Amaya Energy — A connected energy ecosystem',
};

export const SHIFT = {
  statement:
    'The energy landscape is changing. From centralised systems to connected, intelligent networks — power now moves through ecosystems, not pipelines.',
};

export const INTRO = {
  tag: '03 — Amaya Energy',
  title: 'Amaya Energy',
  body: 'One source. Many connections. Amaya Energy is the parent ecosystem where energy brands, technology platforms and infrastructure are built, connected and scaled — together.',
  image:
    'https://images.pexels.com/photos/29224577/pexels-photo-29224577.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600',
};

export const FLOW = {
  tag: '04 — Energy Flow',
  heading: 'One Source. Many Connections.',
  branchLabels: ['Capabilities', 'Brands', 'Markets'],
};

// ---------------------------------------------------------------------------
// PARTNER BRANDS — data-driven. Add a brand = add one object. The ecosystem,
// exploration and animation systems reposition automatically for 2 → 10+.
// ---------------------------------------------------------------------------
export const BRANDS = [
  {
    id: 'maverick',
    name: 'Maverick',
    category: 'Energy Brand',
    status: 'active',
    description:
      'The first brand in the Amaya Energy ecosystem — built to bring energy closer to the people who use it. More soon.',
    image:
      'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?q=80&w=1600&auto=format&fit=crop',
    url: null,
  },
  {
    id: 'future-01',
    name: 'Future Brand',
    category: 'In development',
    status: 'coming-soon',
    description:
      'A new connection in the ecosystem — this node is reserved for an upcoming Amaya Energy brand.',
    image:
      'https://images.pexels.com/photos/14240656/pexels-photo-14240656.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600',
    url: null,
  },
  {
    id: 'future-02',
    name: 'Future Brand',
    category: 'In development',
    status: 'coming-soon',
    description:
      'A new connection in the ecosystem — this node is reserved for an upcoming Amaya Energy brand.',
    image:
      'https://images.pexels.com/photos/13800328/pexels-photo-13800328.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600',
    url: null,
  },
];

export const CAPABILITIES = [
  {
    num: '01',
    title: 'Energy Infrastructure',
    body: 'Developing the physical backbone of the ecosystem — generation, storage and distribution assets built for scale.',
    image:
      'https://images.unsplash.com/photo-1466611653911-95081537e5b7?q=80&w=1600&auto=format&fit=crop',
  },
  {
    num: '02',
    title: 'Technology Platforms',
    body: 'Software and intelligence layers that connect assets, brands and markets into one operating system.',
    image:
      'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=1600&auto=format&fit=crop',
  },
  {
    num: '03',
    title: 'Brand Building',
    body: 'Creating and scaling focused energy brands — each one a specialised node in the wider Amaya network.',
    image:
      'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?q=80&w=1600&auto=format&fit=crop',
  },
  {
    num: '04',
    title: 'Market Operations',
    body: 'Operating across markets with shared capability, shared intelligence and shared momentum.',
    image:
      'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?q=80&w=1600&auto=format&fit=crop',
  },
];

export const MARKETS = [
  {
    name: 'Renewable Generation',
    note: 'Solar, wind and hydro',
    image:
      'https://images.unsplash.com/photo-1509391366360-2e959784a276?q=80&w=1600&auto=format&fit=crop',
  },
  {
    name: 'Storage & Grid',
    note: 'Batteries and resilience',
    image:
      'https://images.unsplash.com/photo-1466611653911-95081537e5b7?q=80&w=1600&auto=format&fit=crop',
  },
  {
    name: 'E-Mobility & Charging',
    note: 'Charging networks',
    image:
      'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?q=80&w=1600&auto=format&fit=crop',
  },
  {
    name: 'Industrial Power',
    note: 'High-demand operations',
    image:
      'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?q=80&w=1600&auto=format&fit=crop',
  },
  {
    name: 'Smart Cities',
    note: 'Connected urban energy',
    image:
      'https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=1600&auto=format&fit=crop',
  },
];

export const GROWTH = {
  tag: '10 — Scale & Growth',
  heading: 'Growth Follows Connection.',
  milestones: ['Origin', 'First connection', 'Ecosystem', 'Expansion', 'What comes next'],
  note: 'The line is the story — every connection compounds.',
};

export const FUTURE = {
  tag: '11 — The Future',
  lines: ['Everything', 'Flows Back', 'To One.'],
  body: 'Every capability, every brand, every market — converging into a single, compounding ecosystem.',
};

export const CTA = {
  lines: ['Build The', 'Next Energy', 'Ecosystem.'],
  primary: 'Partner with Amaya',
  secondary: 'Explore the ecosystem',
};

export const MARQUEE_ITEMS = [
  'Energy in Motion',
  'One Source',
  'Many Connections',
  'A Growing Ecosystem',
];
